import { useCompanyId } from 'application/providers/AccountProvider';
import { useBillingRepositoryInjector } from 'application/providers/DIContainerProvider';

import { UseDiscountViewModel } from './types';

const useDiscountViewModel = (): UseDiscountViewModel => {
  const companyId = useCompanyId();

  const { watchBillingInfo } = useBillingRepositoryInjector();

  const { discount, nextBillingPriceAmount } = watchBillingInfo(companyId);

  return {
    discount,
    nextBillingPriceAmount: nextBillingPriceAmount || 0,
  };
};

export default useDiscountViewModel;
